import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalDataCacheService {
  private _isLocalStorageAvailable: boolean;
  public get isLocalStorageAvailable(): boolean {
    return this._isLocalStorageAvailable;
  }
  constructor() {
    this.checkLocalStorage();
  }
  cacheObject(key: string, obj: any, expiration: Date): void {
    if (!this.isLocalStorageAvailable) return;
    localStorage.setItem(key, JSON.stringify(new CacheItem(expiration, obj)));
  }

  getObject(key: string): any {
    if (!this.isLocalStorageAvailable) return;
    const json = localStorage.getItem(key);
    if (json) {
      const cacheItem = JSON.parse(json);
      if (new Date(cacheItem.expiration) > new Date()) {
        return cacheItem.data;
      } else {
        // delete the expired data
        this.deleteObject(key);
      }
    }
    return null;
  }

  deleteObject(key: string): void {
    if (!this.isLocalStorageAvailable) return;
    localStorage.removeItem(key);
  }

  private checkLocalStorage() {
    try {
      localStorage.x = 1;
      delete localStorage.x;
      this._isLocalStorageAvailable = true;
    } catch (e) {
      this._isLocalStorageAvailable = false;
    }
  }
}

class CacheItem {
  readonly expiration: Date;
  readonly data: any;

  constructor(expiration: Date, data: any) {
    this.expiration = expiration;
    this.data = data;
  }
}
